<template>
    <div>  
        <div class="map-container">
            <Map></Map>
        </div>
    </div>
    <FooterComp></FooterComp>
</template>

<script>
import Map from "../components/InteractiveMap.vue";
import FooterComp from '@/components/Footer_Comp.vue';
export default {
  name: "Location-Map",
  components: {
    Map,
    FooterComp
  }
}
</script>
<style>
.location-body1{
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    gap: 50px;
}
.map-container{
    margin-top: 50px;
    width: 90vw;
}

@media (max-width: 430px){
  .map-container {
  display: flex;
  height: 100%;
  flex-direction: column-reverse;
}
}
</style>